import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Text from "../Text";

var Truncate = /*#__PURE__*/_styled(Text, {
  target: "ewr10np0",
  label: "Truncate"
})(process.env.NODE_ENV === "production" ? {
  name: "bs5mk4",
  styles: "display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
} : {
  name: "bs5mk4",
  styles: "display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RydW5jYXRlL1RydW5jYXRlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUc2QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UcnVuY2F0ZS9UcnVuY2F0ZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBUZXh0IGZyb20gJy4uL1RleHQnO1xuXG5jb25zdCBUcnVuY2F0ZSA9IHN0eWxlZChUZXh0KWBcbiAgZGlzcGxheTogYmxvY2s7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgVHJ1bmNhdGU7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Truncate;